export const defaultTitle = "Something isn't right";
export const defaultDescription = "We can't load some content right now.";
